<template>
    <div class="rf-toolbar" :class="{ sticky }">
        <div>
            <div>
                <slot name="left" />
            </div>
            <div>
                <slot />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Toolbar extends Vue {
    @Prop({ default: true })
    sticky!: boolean
}
</script>

<style lang="scss">
@use "~@restofrit/scss/base/variables.scss" as *;

.rf-toolbar {
    margin: 0 calc(-1 * var(--rf-horizontal-padding, 40px));
    margin-bottom: calc(-1 * var(--rf-vertical-padding, 40px));
    padding-top: var(--rf-vertical-padding, 20px);
    bottom: 0;
    overflow: hidden;
    pointer-events: none; // fix browser bug not able to click through

    &.sticky {
        position: sticky;
    }

    > div {
        padding: 15px var(--rf-horizontal-padding, 40px);
        padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 15px);
        background: $color-white;
        border-top: $border-width solid $color-border;
        display: flex;
        align-items: center;
        justify-content: space-between;
        pointer-events: all;

        > div:first-child {
            min-width: 0;
        }

        > div:last-child {
            flex-shrink: 0;
            display: flex;
            flex-direction: row;
            align-items: stretch;
            min-width: 0;
        }

        > div .button {
            margin-left: 10px;
        }

        @media (max-width: 500px) {
            > div:first-child {
                display: none;
            }

            > div .button, > div .loading-button {
                margin-left: 0;
                margin-right: 0;
                margin-top: 10px;

                &:first-child {
                    margin-top: 0;
                }
            }

            > div:last-child {
                flex-basis: 100%;
                flex-direction: column;

                &> .button {
                    width: 100%;
                    box-sizing: border-box;
                    justify-content: center;
                }
            }
        }
    }
}
</style>
